import React from 'react';
import {Link, Redirect} from 'react-router-dom';

const Home = props => (
  <div id="home">
    <header className="content-header">
      <h1>
        Overview
        <small>of platform data</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <Link to="/">
            <i className="fa fa-dashboard" /> Home
          </Link>
        </li>
        <li>
          <Link to="/">Overview</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <Redirect to="/user-support" />
    </section>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js